import React from 'react';
import { Typography } from '@mui/material';
import PackagesTable from './PackagesTable';

const Packages: React.FC = () => {
  return (
    <div style={{ padding: '20px 40px' }}>
      <Typography variant="h6">Packages</Typography>
      <PackagesTable />
    </div>
  );
};

export default Packages;
